import { useToast } from 'react-native-toast-notifications';
import type { IAlertTop } from './alert';

/**
 * @see https://github.com/arnnis/react-native-toast-notifications
 * @returns toast
 */
export const useAlert = () => {
  const toast: IAlertTop = useToast();
  return toast;
};
